import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LanguageSelector } from './models/';

@Component({
  selector: 'idp-language-selector',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent {
  @Input() content: LanguageSelector = {} as LanguageSelector;
  @Output() openFlyoutModal = new EventEmitter();
  @Output() changeLangEvent = new EventEmitter();
  @Output() analyticsClick = new EventEmitter<Event>();

  open(): void {
    this.openFlyoutModal.emit();
  }

  onLanguageSelectorClick(event: Event): void {
    this.analyticsClick.emit(event);
    this.open();
  }

  changeLanguage(event: Event): void {
    this.analyticsClick.emit(event);
    this.changeLangEvent.emit();
  }
}
